import React, { useEffect, useMemo, useState } from "react"
import TableContainer from "components/Common/TableContainer"
import eye from "../../assets/images/icons/eye.svg"
import { Link, useParams } from "react-router-dom"
import { UncontrolledTooltip } from "reactstrap"

import { useLazyGetTdsQuarterQuery } from "store/api/reports/reports"
import { getTableSortingHeaderIcon, toCapital } from "helpers/common"
import { usePermission } from "hooks/usePermission"
import { PERMISSIONS } from "helpers/roles"
import { useSelector } from "react-redux"

const TdsQuarterTable = ({ type }) => {
  const { year } = useParams()
  const [getResults, { isFetching }] = useLazyGetTdsQuarterQuery()
  const { currentUserMenuType } = useSelector((state) => state.common)
  const filters = {
    page: 1,
    pageSize: 20,
  }
  const [data, setData] = useState([])
  const [count, setCount] = useState(0)
  const { hasPermission } = usePermission()

  //meta title
  document.title = `${
    type === "tds" ? "Tds Quarters" : "Soa months"
  }  | Prachay`

  useEffect(() => {
    getList()
  }, [type, currentUserMenuType])

  const getList = async () => {
    try {
      const { data } = await getResults({
        year,
        type,
        usertype: currentUserMenuType.toLowerCase(),
      }).unwrap()
      setData(data?.rows)
      setCount(data?.count)
    } catch (e) {}
  }

  const columns = useMemo(() => {
    const baseColumns = [
      {
        header: ({ column }) =>
          getTableSortingHeaderIcon(
            column,
            type === "tds" ? "Quarter" : "Month"
          ),

        accessorKey: type === "tds" ? "quarter" : "month",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <>{toCapital(row?.original[type === "tds" ? "quarter" : "month"])}</>
        ),
      },
      {
        header: "Count",
        accessorKey: "Count",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }) => <>{row?.original.count}</>,
      },
      {
        id: "actions",
        header: "Actions",
        cell: ({ row }) => {
          const viewTooltip = `editTooltip-${row?.original?.id}`

          return (
            <div className="d-flex justify-content-center align-items-center gap-3">
              <>
                <div className="action-view">
                  <Link
                    to={`/reports/${type}/${year}/${
                      row?.original[type === "tds" ? "quarter" : "month"]
                    }`}
                    id={viewTooltip}
                  >
                    <img src={eye} alt="" />
                    <UncontrolledTooltip placement="top" target={viewTooltip}>
                      View
                    </UncontrolledTooltip>
                  </Link>
                </div>
                {/* <div
                  className="action-delete"
                  onClick={() => {
                    deleteRef.current = row?.original
                    setIsToast(true)
                  }}
                  id={deleteTooltip}
                >
                  <img src={deleteIcon} alt="" />
                  <UncontrolledTooltip placement="top" target={deleteTooltip}>
                    Delete
                  </UncontrolledTooltip>
                </div> */}
              </>
            </div>
          )
        },
      },
    ]

    const canAccess = hasPermission(PERMISSIONS.REPORT_VIEW)
    if (canAccess) return baseColumns
    return baseColumns.filter((item) => item.id !== "actions")
  }, [type, hasPermission])

  return (
    <>
      <TableContainer
        isLoading={isFetching}
        count={count}
        filters={filters}
        columns={columns}
        data={data}
        isGlobalFilter={true}
        isCustomPageSize={false}
        isPagination={false}
        pagination="pagination"
        paginationWrapper="dataTables_paginate paging_simple_numbers"
        tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
      />

      {/* {isToast && deleteRef && (
        <DeleteConfirmationModal
          open={isToast}
          id={deleteRef?.current?.id}
          setOpen={setIsToast}
          isLoading={isDeleting}
          onClose={() => {
            setIsToast(false)
            deleteRef.current = null
          }}
          title={"Delete Blog"}
          description="Are you sure you want to delete this Blog?"
          onDelete={onDelete}
          onSuccess={onActionSuccess}
        />
      )} */}
    </>
  )
}

export default TdsQuarterTable
